<template>
  <div class="HomeCarousel" :class="{'HomeCarousel-loading':loading}">
    <div v-if="loading">
      <a class="icon is-small center">
        <i class="fas fa-circle-notch fa-spin"></i>
      </a>
    </div>
    <carousel
      v-else
      :perPage="1"
      :paginationEnabled="true"
      :paginationPadding="5"
      paginationActiveColor="#4A4A4A"
      paginationColor="#9B9B9B"
      :navigationEnabled="false"
      :loop="true"
      :autoplay="true"
      :autoplayTimeout="10000"
      :autoplayHoverPause="true"
    >
      <slide style="position:relative;" v-for="(slide,index) in elements" :key="index">
        <!--div class="select" style="float:right;top:20px;z-index:2">
          <select v-model="selectedStyleSubtitle">
            <option value="subtitle"></option>
            <option v-for="i in 7" :key="i">{{i}}</option>
          </select>
          <select v-model="selectedStyleTitle">
            <option value="title"></option>
            <option v-for="i in 7" :key="i">{{i}}</option>
          </select>
        </div-->
        <figure class="image">
          <img
            v-if="slide.mainImage[0]"
            :src="slide.mainImage[0].fileUrl"
            style="object-fit: cover; max-height:560px"
          >
        </figure>
        <transition
          appear
          name=" custom-classes-transition"
          enter-active-class="animated slideInRight"
          leave-active-class="animated bounceOutRight"
        >
          <div
            class="column is-offset-1 is-4-desktop is-6-tablet is-6-mobile has-text-left slide-text-container"
            :class=" {'slide-text-container-mobile':isMobile}"
          >
            <p
              class="is-offset-1 subtitle has-text-weight-bold has-text-left is-uppercase has-text-white slide-subtitle"
              style="margin:0"
            >{{slide.subtitle}}</p>
            <h3
              class="title has-text-weight-light has-text-white slide-title"
              :class="{'is-hidden':isMobile}"
              style="margin:5px auto !important"
            >{{slide.title}}</h3>
            <button
              class="button is-primary is-rounded is-uppercase has-text-weight-bold startButton is-size-7-mobile"
              v-t="'App.start'"
              @click="$emit('buttonClick')"
            ></button>
            <!--a class="button is-primary is-rounded is-uppercase has-text-weight-bold startButton is-small-mobile" v-t="'App.register'" :href="register_url" target='blank' v-else-->
            <!--/a-->
          </div>
        </transition>
      </slide>
    </carousel>
  </div>
</template>
<script>
import { Carousel, Slide } from 'vue-carousel'
import { mapState, mapActions, mapGetters } from 'vuex'
export default {
  components: {
    Carousel,
    Slide
  },
  mounted () {
    return this.getHomeCarousel().catch()
  },
  data () {
    return {
      register_url: process.env.VUE_APP_REGISTER_URL,
      selectedStyleSubtitle: 2,
      selectedStyleTitle: 3
    }
  },
  computed: {
    ...mapState({
      homeCarousel: state => state.CRUD.homeCarousel,
      loading: state => state.CRUD.pending.homeCarousel
    }),
    ...mapGetters(['isLoggedIn']),
    elements: function () {
      return this.homeCarousel ? this.homeCarousel.elements : []
    },
    isMobile: function () {
      return this.$mq === 'mobile'
    }
  },
  methods: {
    ...mapActions(['getHomeCarousel'])
  }
}
</script>

<style lang="scss" scoped>
.VueCarousel {
  padding: unset !important;
}
.HomeCarousel-loading {
  height: 37.5rem !important;
}

.center {
  position: absolute;
  top: 40%;
}

.slide-text-container {
  position: absolute;
  top: 90px;
}
.slide-text-container-mobile {
  position: absolute;
  top: 45px !important;
}
.slide-title {
  font-size: 36px;
}
.slide-subtitle {
  font-size: 14px;
}
.startButton {
  margin-top: 20px;
}
</style>
